import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div  className='bg-black text-center p-6 text-white border-t-2 border-gray-500 '>
      Copyright © {new Date().getFullYear()} <Link to='/tnc'><span className='text-yellow-400'>Gaming</span></Link>
    </div>
  )
}

export default Footer
